import { redirect } from "react-router-dom";

export const PrivatePath = ({ children }) => {
  if (!sessionStorage.getItem("isLoggedin")) {
    return redirect("/");
  } else{
    return children;
  }
  
};